module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-thinking.6009d307.png";